import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { mapState } from "vuex";
import unitTreeModal from "../Modal/unitTreeModal.vue";
import request from "@/service/identity";
export default {
  data() {
    return {
      title: "title",
      visible: false,
      config: {
        code: "",
        name: "",
        unitIds: [],
        permissionCodes: []
      },
      entityList: []
    };
  },
  methods: {
    onVisibleChange(visiable) {
      if (!visiable) {
        this.config = {
          code: "",
          name: "",
          unitIds: "",
          permissionCodes: []
        };
        this.entityList = [];
      }
    },
    updateIdentity(entityList) {
      this.entityList = entityList;
    },
    open(title, config) {
      this.title = title;
      this.config = config;
      this.visible = true;
    },
    selectScope(value) {
      if (value === "curr") {
        this.config.unitIds = [];
      } else {
        this.$refs.orgTreeModalRef.open([]);
      }
    },
    setUnitIds(unitIds) {
      this.config.unitIds = unitIds;
    },
    async confirm() {
      let {
        code,
        name
      } = this.config;
      console.log(this.config);
      let unitIds = this.entityLists;
      let params = {
        code,
        name,
        unitIds,
        permissionCodes: []
      };
      let {
        data: {
          result
        }
      } = await request.createOrUpdateIdentity(params);
      if (result === 0) {
        this.visible = false;
      }
    },
    cancel() {
      this.visible = false;
    }
  },
  computed: {
    ...mapState({
      originMenuList: state => state.user.menuList
    }),
    entityLists() {
      return this.entityList.map(item => {
        return item.key;
      });
    },
    width() {
      return window.innerWidth > 1000 ? "600" : "80";
    }
  },
  components: {
    unitTreeModal
  }
};